import { InjectedConnector } from '@web3-react/injected-connector';

export const injectedConnector = new InjectedConnector({
    supportedChainIds: [
      1, // Mainet
      3, // Ropsten
      4, // Rinkeby
      5, // Goerli
      42, // Kovan
      56, // BSC Mainnet
      97, // BSC Testnet
      269, // HPB
      4690,//IOTEX Testnet
      137,//Matic Mainnet
      80001,//Mumbai Testnet
      250,//Fantom Mainnet
      4002,//Fantom Testnet
      1819,//Cube Testnet
      1666600000,//One MainNet
    ],
  });
